import React from "react";
import finanzz from "../images/BLUE FEV.png";
import New360ERP from "../images/360 Degree Erp Logo.png";
import { Link } from "react-router-dom";

export default function Footer() {
  return (<>
    <footer className="main-footer " >
      <div className="sub-footer !tw-shadow-[0_8px_30px_rgba(0,0,0,0.015)] tw-mb-2">

        <Link to="/dashboard" style={{ display: "flex", justifyContent: "center" }}>
          <img
            src={process.env.REACT_APP_FINANZZ_URL === "360" ? New360ERP : finanzz}
            alt="Logo..."
            className="tw-w-6 tw-h-6 tw-object-contain tw-ml-2"
          />
          {process.env.REACT_APP_FINANZZ_URL === "360" && (
            <p className="tw-my-0 tw-ml-2 tw-font-semibold tw-text-[#0a2532]">360 ERP</p>
          )}
        </Link>
        {/* <div className="textColour text-bold float-right"><b>Version</b> 1.0.0</div> */}
        {/* <br/> */}
        {/* <div className="tw-text-base">
      Copyright©2023-24 <span className="textColour text-bold">Finanzz</span>  All rights reserved.
      </div> */}
        <p className="text-xs text-slate-400 font-medium my-0">
          © 2023-2026{" "}
          <span className="tw-font-semibold tw-text-slate-500">
            {process.env.REACT_APP_FINANZZ_URL === "360"
              ? "360 Enterprise Resource Planning"
              : "Jnana Technologies"}
          </span>
          . All rights reserved.
        </p>
        {/* <p className="tw-text-[10px] tw-text-slate-400/80 tw-mt-1">Made with ❤️ by Jnana Team</p> */}
      </div>
      {/* <div className="d-flex justify-content-start">Powered by<span className="textColour text-bold">&nbsp;Jnana Technologies&nbsp;</span> @{moment().format("yyyy")}</div> */}
    </footer >
  </>);
}
